<template>
    <div class="Field__Component">
        <div>
            <slot>
                <div @click="deleteFile">
                    <b-icon pack="fa" icon="trash"></b-icon>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import { 
    DialogProgrammatic as Dialog,
    ToastProgrammatic as Toast,
    LoadingProgrammatic as Loading,
 } from 'buefy';
import AdminService from '../../services/AdminService';

export default {
    name: 'FieldDeleteFile',
    props: ['value', 'item', 'search'],
    methods: {
        deleteFile() {
            let folderType;
            if (this.item.fileUrl.includes('SiteImages')) folderType = 1;
            else if (this.item.fileUrl.includes('BookImages')) folderType = 2;
            else if (this.item.fileUrl.includes('Messages')) folderType = 3;
            else if (this.item.fileUrl.includes('Lectures')) folderType = 5;
            else if (this.item.fileUrl.includes('Emails')) folderType = 6;
            else if (this.item.fileUrl.includes('HomePage')) folderType = 7;
            else if (this.item.fileUrl.includes('Laws')) folderType = 8;
            else if (this.item.fileUrl.includes('FlipCardFiles')) folderType = 9;
            if (!folderType) {
                Toast.open({
                    type: 'is-danger',
                    message: 'לא היה ניתן לבצע את הפעולה, נסה למחוק שוב.',
                    duration: 8000,
                });
                return;
            }
            Dialog.confirm({
                message: 'האם למחוק את הקובץ?',
                confirmText: 'כן',
                cancelText: 'לא',
            })
                .then(({ result }) => {
                    if (result) {
                        const loading = Loading.open({
                            isFullPage: true,
                        });
                        AdminService
                            .delteFileFromStorage(folderType, this.item.fileName)
                            .then(() => {
                                this.search();
                                Toast.open({
                                    type: 'is-success',
                                    message: 'הקובץ נמחק בהצלחה!',
                                    duration: 4000,
                                });
                            })
                            .catch(() => {
                                Toast.open({
                                    type: 'is-danger',
                                    message: 'לא היה ניתן לבצע את הפעולה, נסה למחוק שוב.',
                                    duration: 8000,
                                });
                            })
                            .finally(() => {
                                loading.close();
                            });
                    }
                });
            AdminService
        }
    }
};
</script>

<style scoped>
.Field__Component div {
    text-decoration: underline;
    color: red !important;
    cursor: pointer;
    /* text-align: center; */
    /* display: block; */
}
</style>
